import * as queryStringHelpers from "../../lib/queryStringHelpers";
import ErrorBoundary from "../ErrorBoundary";
import Footer from "../Footer";
import Header from "../Header";
import React, {useEffect} from "react";
import SetNoIndex from "../../lib/SetNoIndex";
import styles from "./ProcessingPage.module.css";
import TextLink from "../TextLink";
import useLeadsRX from "../../lib/useLeadsRX";
import usePageView from "../../lib/usePageView";
import {Container, Column, Row} from "../grid";

const strings = {
    title: "1st Financial Bank USA Card Request Processing",
    header: "Thank you for your application",
    p1: (defaultCardBrand: string) =>
        `Your application for a 1st Financial Bank USA ${
            defaultCardBrand === "VISA" ? "Visa" : "Mastercard"
        } credit card account has been recorded.`,
    p2:
        "Once we have completed the processing of your application, you will receive a letter in the mail that tells you if your application has been approved - and, if approved, your card should arrive 10-14 days later. We have up to 30 days to notify you of the action taken on your application.",
    p3: "If you have any questions, just call our Customer Service Representatives at",
    phone: "1-800-733-1732",
};

const LRX_CODE = 14396;

export default function ProcessingPage() {
    useEffect(() => {
        document.title = strings.title;
    }, []);

    SetNoIndex();
    usePageView(strings.title);
    useLeadsRX(LRX_CODE);

    const queryParams = queryStringHelpers.objectify(window.location.search);
    const defaultCardBrand = queryParams[queryStringHelpers.Keys.CardBrand] ?? "VISA";

    return (
        <ErrorBoundary>
            <Header />
            <Container className={styles.container}>
                <Row className={styles.titleRow}>
                    <Column>
                        <h1 className={styles.title}>{strings.header}</h1>
                    </Column>
                </Row>
                <Row className={styles.p1Row}>
                    <Column>
                        <div className={styles.paragraph}>{strings.p1(defaultCardBrand)}</div>
                    </Column>
                </Row>
                <Row className={styles.p2Row}>
                    <Column>
                        <div className={styles.paragraph}>{strings.p2}</div>
                    </Column>
                </Row>
                <Row className={styles.p3Row}>
                    <Column>
                        <div className={styles.paragraph}>
                            {strings.p3}{" "}
                            <TextLink
                                openInSameTab={true}
                                className={styles.link}
                                href="tel:800-733-1732"
                                text={strings.phone}
                            />
                            .
                        </div>
                    </Column>
                </Row>
            </Container>
            <Footer />
        </ErrorBoundary>
    );
}
